// tslint:disable:max-classes-per-file insecure-random
import React, { Component } from "react";
import { Particle, random, } from "./Particle";
const { round, floor, PI, random: randomNumber } = Math;
const dpi = window !== undefined ? window.devicePixelRatio : 1;
export class Particles extends Component {
    constructor(props) {
        super(props);
        this.canvas = null;
        this.isRendering = false;
        this.lastTimestamp = 0;
        this.lifetimeParticles = 0;
        this.particles = {};
        this.canvasWidth = round(this.props.width * dpi);
        this.canvasHeight = round(this.props.height * dpi);
        this.onFrame = this.onFrame.bind(this);
        this.canvasRef = this.canvasRef.bind(this);
    }
    emit({ frequency, initialVelocity, location, colors, acceleration, startDyingAt, lifetime, radius, wander, friction, spawnUntil, }) {
        let num = frequency < 1 ? (randomNumber() <= frequency ? 1 : 0) : floor(frequency);
        while (num--) {
            const color = random.arrayItem(colors)();
            this.particles[color] = this.particles[color] || {};
            this.particles[color][this.lifetimeParticles++] = this.randomParticle(acceleration, initialVelocity, color, location, startDyingAt, lifetime, radius, wander, friction, spawnUntil);
        }
    }
    randomParticle(acceleration, initialVelocity, color, location, startDyingAt, lifetime, radius, wander, friction, spawnUntil) {
        const v = initialVelocity();
        return Particle.get(color, radius(), location(), v, acceleration(v), wander, startDyingAt, lifetime(), friction, spawnUntil());
    }
    setupCanvas(canvas) {
        this.canvas = canvas;
        canvas.width = this.canvasWidth;
        canvas.height = this.canvasHeight;
        canvas.style.width = `${this.props.width}px`;
        canvas.style.height = `${this.props.height}px`;
    }
    start() {
        if (this.isRendering) {
            return;
        }
        this.isRendering = true;
        this.lastTimestamp = performance.now();
        this.onFrame(this.lastTimestamp);
    }
    stop() {
        this.isRendering = false;
    }
    canvasRef(ref) {
        if (ref === null) {
            this.stop();
            this.canvas = null;
            return;
        }
        this.setupCanvas(ref);
        this.start();
        for (const e of this.props.emitters) {
            this.emit(Object.assign(Object.assign({}, e), { frequency: e.initialSpawn }));
        }
    }
    onFrame(timestamp) {
        if (!this.canvas) {
            return this.stop();
        }
        for (const e of this.props.emitters) {
            this.emit(e);
        }
        const delta = (timestamp - this.lastTimestamp) / 1000;
        const ctx = this.canvas.getContext("2d");
        ctx.save();
        if (this.props.blur && this.props.background) {
            ctx.fillStyle = `rgba(${this.props.background.join(",")}, ${this.props.blur})`;
            ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
        }
        else {
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
        }
        ctx.scale(dpi, dpi);
        // tslint:disable-next-line:no-for-in
        for (const color in this.particles) {
            if (!this.particles.hasOwnProperty(color)) {
                continue;
            }
            const particles = this.particles[color];
            // Grouped by color for perf reasons.
            ctx.fillStyle = color;
            // tslint:disable-next-line:no-for-in
            for (const k in particles) {
                if (!particles.hasOwnProperty(k)) {
                    continue;
                }
                const p = particles[k];
                p.tick(delta);
                if (p.isDead) {
                    Particle.return(this.particles[p.color][k]);
                    delete this.particles[p.color][k];
                    continue;
                }
                ctx.beginPath();
                ctx.arc(p.location[0], p.location[1], p.radius, 0, PI * 2);
                ctx.fill();
            }
        }
        ctx.restore();
        if (this.isRendering) {
            this.lastTimestamp = timestamp;
            requestAnimationFrame(this.onFrame);
        }
    }
    // Currently blocks changes to component width/height,
    // which should be fine for our uses.
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return (React.createElement("div", { className: this.props.className, style: {
                width: this.props.width + "px",
                height: this.props.height + "px",
            } },
            React.createElement("canvas", { ref: this.canvasRef })));
    }
}
//# sourceMappingURL=Particles.js.map